import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useWeb3React } from '@web3-react/core';
import { PointsRepository } from '../../connectors/repositories/points';
import { formatPoints } from '../../helpers/quests';
import { shortenAddress } from '../../helpers/format';

export const PointsLeaderboard = ({ refreshKey }) => {
  const { t } = useTranslation();
  const { account } = useWeb3React();
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!account) return;
    PointsRepository.getLeaderboard(account)
      .then(setData)
      .catch(() => {});
  }, [account, refreshKey]);

  if (!data?.items?.length) {
    return <span className="text-[1.4rem] text-white-500 p-[2rem]">{t('quests.leaderboard.empty')}</span>;
  }

  return (
    <div className="flex flex-col">
      {data.me?.rank && (
        <div className="flex items-center justify-between py-[1.4rem] px-[2rem] bg-[rgba(152,90,255,0.10)] rounded-[1.2rem] mb-[0.8rem]">
          <span className="text-[1.4rem] text-white">{t('quests.leaderboard.you', { rank: data.me.rank })}</span>
          <span className="text-[1.6rem] font-600 text-white">{formatPoints(data.me.points)} PP</span>
        </div>
      )}
      {data.items.map((item) => (
        <div
          key={item.rank}
          className="flex items-center justify-between py-[1.4rem] px-[2rem] border-b-[0.1rem] border-solid border-white-50 last:border-b-0"
        >
          <div className="flex items-center space-x-[1.2rem] min-w-0">
            <span className="w-[3.2rem] text-[1.4rem] font-600 text-white-500">#{item.rank}</span>
            <span className="text-[1.4rem] text-white truncate">{item.nickname || shortenAddress(item.address)}</span>
          </div>
          <span className="text-[1.6rem] font-600 text-white">{formatPoints(item.points)} PP</span>
        </div>
      ))}
    </div>
  );
};
